import styled from "styled-components";
import Card from "../../../components/custom/Card";
import { IUser, SupportTicket } from "../../../globals/interfaces";
import { formatDatetime } from "../../../utils";
import { useSetRecoilState } from "recoil";
import { selectedTicketIdState, supportRequestModalState, supportTicketsState } from "./atoms";
import _ from "lodash";
import { getUnreadMessagesCount } from ".";
import UnreadMessagesCount from "./UnreadMessagesCount";

export default function TicketCard({
    item,
    user
}: {
    item: SupportTicket;
    user: IUser;
}) {

    const setTickedId = useSetRecoilState(selectedTicketIdState);
    const setSupportRequestModal = useSetRecoilState(supportRequestModalState);
    const unreadMessagesCount = getUnreadMessagesCount(item, user);

    const viewTicket = () => {
        setTickedId(item.id);
        setSupportRequestModal(true);
    }

    return (
        <CustomCard onClick={viewTicket} className={'hover'}>
            <h6>{item.unit}-{item.id}</h6>
            <h6>{item.createdBy}</h6>
            <FlexContainer>
                <h6>{formatDatetime(item.createdAt)}</h6>
                <UnreadMessagesCount unreadMessagesCount={unreadMessagesCount} />
            </FlexContainer>
        </CustomCard>
    );
}

const CustomCard = styled(Card)`
    max-width: 400px;
`;

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;